angular.module('callX').directive('dateInputMask', function() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.on('input', function() {
                var value = element.val();
                value = value.replace(/[^0-9\/]/g, ''); // Remove non-numeric characters except for "/"
                
                if (value.length > 2 && value[2] !== '/') {
                    value = value.slice(0, 2) + '/' + value.slice(2);
                }
                if (value.length > 5 && value[5] !== '/') {
                    value = value.slice(0, 5) + '/' + value.slice(5);
                }
                if (value.length > 10) {
                    value = value.slice(0, 10);
                }

                element.val(value);
            });
        }
    };
});
